export const LEGAL_ZOOM_VIRTUAL_MAIL_PAGE = 'https://www.legalzoom.com/business/business-operations/lz-virtual-mail-overview.html'

export const LEGAL_ZOOM_VIRTUAL_MAIL_PAGE_WITH_STRIPE_PARAMS = (() => {
  const url = new URL(LEGAL_ZOOM_VIRTUAL_MAIL_PAGE)
  url.searchParams.set('utm_source', 'atlas_dashboard')
  url.searchParams.set('utm_campaign', 'first_intro')

  return url.toString()
})()
